import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=ed3181ba"
import script from "./EditTag.vue?vue&type=script&lang=js"
export * from "./EditTag.vue?vue&type=script&lang=js"
import style0 from "./EditTag.vue?vue&type=style&index=0&id=ed3181ba&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed3181ba')) {
      api.createRecord('ed3181ba', component.options)
    } else {
      api.reload('ed3181ba', component.options)
    }
    module.hot.accept("./EditTag.vue?vue&type=template&id=ed3181ba", function () {
      api.rerender('ed3181ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/employeeCompanyTag/components/EditTag.vue"
export default component.exports